module.exports = __webpack_public_path__ + "static/media/skyscout-monocular-5.1723eb28.jpg";